module.exports = __webpack_public_path__ + "static/media/dst-icon-purple.fc4c7bc2.svg";